module.exports = __webpack_public_path__ + "static/media/Mondadori-logomark.2b5e64e4.svg";